import React, { useContext } from 'react';
import { Content } from './styles';
import { ThemeContext } from 'styled-components';

const TableRow = props => {
  const random = Math.random() * (1 - 0.7) + 0.7;
  return (
    <Content height={38} width={1060} speed={1.2} {...props}>
      <rect x="10" y="13" rx="6" ry="6" width={75 * random} height="8" />
      <rect x="100" y="13" rx="6" ry="6" width={200 * random} height="8" />
      <rect x="330" y="13" rx="6" ry="6" width={180 * random} height="8" />
      <rect x="580" y="13" rx="6" ry="6" width={78 * random} height="8" />
      <rect x="680" y="13" rx="6" ry="6" width={100 * random} height="8" />
      <rect x="800" y="13" rx="6" ry="6" width={80 * random} height="8" />
      <rect x="938" y="13" rx="6" ry="6" width={83 * random} height="8" />
    </Content>
  );
};

const TableRowPendentes = props => {
  const random = Math.random() * (1 - 0.7) + 0.7;
  return (
    <Content height={38} width={1060} speed={1.2} {...props}>
      <rect x="10" y="13" rx="6" ry="6" width={75 * random} height={8} />
      <rect x="180" y="13" rx="6" ry="6" width={300 * random} height="8" />
      <rect x="680" y="13" rx="6" ry="6" width={200 * random} height="8" />
      <rect x="950" y="13" rx="6" ry="6" width={80 * random} height="8" />
      {/* <rect x="330" y="13" rx="6" ry="6" width={180 * random} height="8" />
      <rect x="580" y="13" rx="6" ry="6" width={78 * random} height="8" />
      <rect x="680" y="13" rx="6" ry="6" width={100 * random} height="8" />
      <rect x="800" y="13" rx="6" ry="6" width={80 * random} height="8" />
      <rect x="938" y="13" rx="6" ry="6" width={83 * random} height="8" /> */}
    </Content>
  );
};

const Table = ({ type }) => {
  const themeContext = useContext(ThemeContext);

  switch (type) {
    case 'materiais':
      return (
        <>
          {Array(5)
            .fill('')
            .map((e, i) => (
              <TableRow
                key={i}
                style={{ opacity: Number(2 / i).toFixed(1) }}
                backgroundColor={themeContext?.loadingTableColor}
                foregroundColor={themeContext?.loadingTableColor}
                primaryopacity={1}
                secondaryopacity={0.6}
              />
            ))}
        </>
      );
    case 'pendentes':
      return (
        <>
          {Array(5)
            .fill('')
            .map((e, i) => (
              <TableRowPendentes
                key={i}
                style={{ opacity: Number(2 / i).toFixed(1) }}
                primaryColor={themeContext?.loadingTableColor}
                secondaryColor={themeContext?.loadingTableColor}
              />
            ))}
        </>
      );

    default:
      return (
        <>
          {Array(5)
            .fill('')
            .map((e, i) => (
              <TableRow
                key={i}
                style={{ opacity: Number(2 / i).toFixed(1) }}
                backgroundColor={themeContext?.loadingTableColor}
                foregroundColor={themeContext?.loadingTableColor}
              />
            ))}
        </>
      );
  }
};

export default Table;
